import { GetBookingDocument, GetBookingQuery } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export type BookingNode = NonNullable<GetBookingQuery['spaceControl']['booking']>

export const useBooking = (id: number) => {
  const { loading, data } = useQuery(GetBookingDocument, { variables: { id } })

  return {
    loading,
    booking: data ? data.spaceControl.booking : undefined,
  }
}
